// Українська — основна мова бота (за замовчуванням).
export const uk: Record<string, string> = {
  'app.name': 'VolleyBot',
  'app.loading': 'Завантаження…',
  'app.youreAllSet': 'Все готово!',
  'app.loadingHome': 'Завантажуємо головну сторінку…',

  'nav.home': 'Головна',
  'nav.games': 'Ігри',
  'nav.create': 'Створити',
  'nav.profile': 'Профіль',
  'nav.admin': 'Admin',
  'nav.test': 'Тест',
  'status.open': 'Відкрита',
  'status.full': 'Заповнена',
  'status.going': 'Йде зараз',
  'status.cancelled': 'Скасована',
  'status.finished': 'Завершена',

  'welcome.title': 'Ласкаво просимо у VolleyBot',
  'welcome.subtitle': 'Оберіть свій рівень гри, щоб почати.',
  'welcome.cta': 'Продовжити',
  'welcome.done.title': 'Все готово!',
  'welcome.done.subtitle': 'Завантажуємо головну сторінку…',
  'welcome.hello': 'Привіт, {name}!',
  'welcome.intro':
    'VolleyBot допомагає знаходити та організовувати волейбольні ігри у вашому місті. Налаштуймо ваш профіль за 30 секунд.',
  'welcome.feature.findGames.title': 'Знаходьте ігри поруч',
  'welcome.feature.findGames.desc': 'Відкриті ігри у вашому місті, відфільтровані за рівнем гри.',
  'welcome.feature.join.title': 'Приєднуйтесь одним дотиком',
  'welcome.feature.join.desc': 'Бачте, хто грає, діліть вартість корту, отримуйте нагадування.',
  'welcome.feature.organize.title': 'Організуйте власну гру',
  'welcome.feature.organize.desc': 'Оберіть місце, час і рівень — запросіть гравців за секунди.',
  'welcome.getStarted': 'Почати',
  'welcome.footNote': 'Це завжди можна змінити у Профілі.',
  'welcome.skill.title': 'Який у вас рівень гри?',
  'welcome.skill.subtitle':
    'Оберіть рівень, який найкраще описує вашу гру. Ми підберемо вам ігри з відповідним рівнем.',
  'welcome.skill.cta': 'Продовжити',
  'welcome.skill.saving': 'Збереження…',
  // Welcome page when opened from a "change my level" tap.
  'welcome.changeMode.title': 'Змінити рівень гри',
  'welcome.changeMode.subtitle':
    'Оберіть рівень, який найкраще описує вашу гру зараз. Це вплине на рекомендації ігор.',
  'welcome.changeMode.cta': 'Зберегти рівень',
  'welcome.changeMode.successTitle': 'Рівень оновлено',
  'welcome.changeMode.successSub': 'Новий рівень збережено. Він діятиме для наступних ігор.',

  'skill.LEVEL_1': 'Початківець',
  'skill.LEVEL_2': 'Початківець (Аматор)',
  'skill.LEVEL_3': 'Середній',
  'skill.LEVEL_4': 'Просунутий',
  'skill.LEVEL_5': 'Напівпрофі',
  'skill.LEVEL_6': 'Професіонал',
  'skill.LEVEL_1.desc':
    'Знає правила, але базові елементи (прийом, подача, передача) поки нестабільні.',
  'skill.LEVEL_2.desc': 'Верхня подача, позиційний захист, простий прийом.',
  'skill.LEVEL_3.desc': 'Стабільний прийом, впевнені атаки, перші спроби групового блоку.',
  'skill.LEVEL_4.desc':
    'Впевнена гра з пасуючим, атаки першим темпом, потужні та тактичні подачі.',
  'skill.LEVEL_5.desc': 'Глибоке тактичне розуміння, потужні подачі, відпрацьовані комбінації.',
  'skill.LEVEL_6.desc': 'Колишні профі, майстри спорту, відмінна техніка, блискавична командна робота.',
  'skill.wheelchair': 'Спортсмен на візку',

  'home.title': 'Головна',
  'home.hello': 'Привіт, {name}!',
  'home.botAlerts': 'Сповіщення про ігри в чаті бота',
  'home.botAlertsSub': 'Дозвольте повідомлення, щоб зміни гри приходили в цей чат.',
  'home.upcomingGames': 'Майбутні ігри',
  'home.seeAll': 'Усі ігри',
  'home.noGames': 'Майбутніх ігор ще немає',
  'home.findGame': 'Знайти гру',
  'home.createGame': 'Створити гру',
  'home.createGameSub': 'Запросіть гравців за секунди',
  'home.pickYourLevel': 'Оберіть свій рівень гри',
  'home.pickYourLevelSub': 'Розкажіть іншим гравцям про свій рівень, щоб вас могли підібрати у команду.',
  'home.openGames': 'Відкриті ігри',
  'home.freeSpots': 'Вільні місця',
  'home.allGames': 'Усі ігри',
  'home.openGamesInCity': '{count} відкритих ігор у вашому місті.',
  'home.noGamesSub': 'Ігор ще немає - створіть першу.',
  'home.emptyCta': 'Створіть першу волейбольну гру в {city}. Натисніть "Створити гру", щоб почати.',
  'home.tapToChangeLevel': 'Натисніть, щоб змінити рівень гри',
  'home.ratePlayers': 'Оцініть гравців',
  'home.ratePlayersSub': 'Допоможіть скоригувати рівні після останньої гри',

  'profile.title': 'Профіль',
  'profile.about': 'Про вас',
  'profile.age': 'Вік',
  'profile.city': 'Місто',
  'profile.language': 'Мова',
  'profile.bio': 'Коротко про себе (необов\'язково)',
  'profile.skill': 'Рівень гри',
  'profile.skillFromEvaluations': 'На основі {n} оцінок',
  'profile.save': 'Зберегти',
  'profile.saved': 'Профіль збережено',
  'profile.signOut': 'Вийти',
  'profile.signOutConfirm': 'Вийти з VolleyBot?',
  'profile.adminPanel': 'Адмін-панель',
  'profile.blacklist': 'Заблоковані гравці',
  'profile.invitations': 'Запрошення',
  'profile.payments': 'Платежі',
  'profile.status.admin': 'Адмін',
  'profile.tapToChangeLevel': 'Натисніть, щоб змінити рівень гри',

  'games.title': 'Ігри',
  'games.filter.city': 'Місто',
  'games.filter.skill': 'Рівень',
  'games.filter.skillAny': 'Будь-який рівень',
  'games.filter.bucket.beginner': 'Початківець',
  'games.filter.bucket.intermediate': 'Середній',
  'games.filter.bucket.advanced': 'Просунутий',
  'games.filter.dateFrom': 'З',
  'games.filter.dateTo': 'По',
  'games.filter.spots': 'Місць',
  'games.filter.any': 'Будь-яка',
  'games.filter.search': 'Пошук у нотатках',
  'games.filter.apply': 'Застосувати',
  'games.filter.clear': 'Очистити',
  'games.filter.quick.all': 'Усі',
  'games.filter.quick.open': 'Відкриті',
  'games.filter.quick.today': 'Сьогодні',
  'games.filter.quick.free': 'Безкоштовні',
  'games.filter.quick.indoor': 'Зал',
  'profile.editProfile': 'Редагувати профіль',
  'profile.doneEditing': 'Готово',
  'profile.activity': 'Активність',
  'profile.gamesHosted': 'Ігор створено',
  'profile.gamesJoined': 'Ігор зіграно',
  'games.empty': 'Ігор за вашими фільтрами не знайдено.',

  'game.spots': '{count} / {total} місць',
  'game.spotsFull': 'Все зайнято',
  'game.waitlistNotify': 'Повідомити мене',
  'game.waitlistSubscribed': 'Стежу',
  'game.waitlistStop': 'Стоп',
  'game.waitlistHint': 'Надішлемо повідомлення в Telegram, коли хтось вийде.',
  'game.waitlistToast': 'Ок — напишемо в Telegram, якщо звільниться місце.',
  'game.waitlistToastOff': 'Більше не стежимо за цією грою.',
  'game.changeTime': 'Змінити час',
  'game.changeTimeTitle': 'Перенести гру',
  'game.changeTimeHint': 'Гравці в складі отримають сповіщення в Telegram з новим часом.',
  'game.changeTimeSave': 'Зберегти новий час',
  'game.changeTimeCurrent': 'Зараз: {when}',
  'game.changeTimeInvalid': 'Оберіть час у майбутньому.',
  'game.changeTimeSame': 'Це той самий час — нічого змінювати.',
  'game.changeTimeDone': 'Час оновлено. Гравців повідомлено.',
  'game.edit': 'Редагувати гру',
  'game.editTitle': 'Редагувати гру',
  'game.editHint': 'Змініть місце, тип, час, рівень, кількість місць або ціну. Усі, хто записався, отримають повідомлення в Telegram, якщо хоча б раз відкривали бота.',
  'game.editPriceHint': '0 лишає гру безкоштовною. Більша сума ділиться на місця.',
  'game.editPriceInvalid': 'Вкажіть ціну або 0, щоб гра лишилась безкоштовною.',
  'game.editSave': 'Зберегти',
  'game.editDone': 'Гру оновлено.',
  'game.editNoChanges': 'Нічого не змінено.',
  'game.editAddressRequired': 'Адреса обов’язкова.',
  'game.editSpotsMin': 'Мінімум 2 місця.',
  'game.editSpotsBelowRoster': 'Не можна менше за поточних гравців ({n}).',
  'game.spotsOneLeft': 'Залишилось 1 місце',
  'game.spotsLeft': 'Залишилось {n} місць',
  'game.perPlayer': '{amount} / гравець',
  'game.closed': 'Закрите лобі',
  'game.closedHint': 'Лише за запрошенням — надішліть запит і організатор схвалить.',
  'game.hidePlayers': 'Приховати гравців від сторонніх',
  'game.hidePlayersHint': 'Хто не в грі, бачить склад як Інкогніто. Учасники бачать усіх.',
  'game.playersHiddenBanner': 'Список гравців приховано, доки ви не приєднаєтесь.',
  'game.playersHiddenHint': 'Приєднайтесь, щоб побачити склад',
  'create.field.hidePlayers': 'Приховати гравців від сторонніх',
  'game.paid': 'Платна гра',
  'game.free': 'Безкоштовна гра',
  'game.host': 'Організатор',
  'game.perPlayerShort': '/ гравець',
  'game.playersShort': 'гравців',
  'game.playersMore': 'ще {count}',
  'game.spotsLeftShort': '{count} вільно',
  'game.playType.indoor': 'У залі',
  'game.playType.outdoor': 'На вулиці',
  'game.playType.beach': 'На пляжі',
  'game.join': 'Приєднатися',
  'game.leave': 'Вийти',
  'game.cancel': 'Скасувати гру',
  'game.finish': 'Завершити гру',
  'game.requestToJoin': 'Подати запит',
  'game.requestPending': 'Запит надіслано',
  'game.joinRequests': 'Запити на вступ ({n})',
  'game.approveRequest': 'Прийняти',
  'game.rejectRequest': 'Відхилити',
  'game.finishConfirm': 'Позначити гру як завершену?',
  'game.cancelConfirm': 'Скасувати цю гру?',
  'game.evaluations': 'Оцінити гравців',
  'game.managePayments': 'Оплати',
  'game.invitePlayers': 'Запросити гравців',
  'game.share': 'Поділитися',
  'game.shareHeadline': 'Відкрита гра — хто з нами?',
  'game.shareCta': 'Відкрити й приєднатися:',
  'game.shareSpots': '{filled}/{total} гравців · {left} вільних',
  'game.shareSpotsFull': '{filled}/{total} гравців · місць немає',
  'game.shareFree': 'Безкоштовно',
  'game.shareSkill': 'Рівень {n}',
  'game.shareUnavailable': 'Поділитися поки неможливо — спробуй трохи згодом.',
  'game.reserve': 'Забронювати місце',
  'game.reserveHint': 'Тримає місце для того, хто не може записатися зараз. Інші бачать лише «Інкогніто».',
  'game.reserveNote': 'Приватна нотатка',
  'game.reserveNotePlaceholder': 'Для кого? (бачиш лише ти)',
  'game.reserveRemove': 'Звільнити',
  'game.reservedSpots': 'Бронь ({n})',
  'game.incognito': 'Інкогніто',
  'game.incognitoHint': 'Місце зайняте — ще не в застосунку',

  'gameDetail.players': 'Гравці',
  'gameDetail.noPlayers': 'Ще немає гравців',
  'gameDetail.address': 'Адреса',
  'gameDetail.startsAt': 'Початок',
  'gameDetail.notes': 'Нотатки',
  'gameDetail.cover': 'Фото майданчика',
  'gameDetail.roleOrganizer': 'Організатор',
  'gameDetail.rolePlayer': 'Гравець',
  'gameDetail.tagHost': 'ОРГАНІЗАТОР',
  'gameDetail.tagYou': 'ВИ',
  'gameDetail.reportAction': 'Поскаржитися',
  'gameDetail.actionsFor': 'Дії для {name}',
  'gameDetail.tabPlayers': 'Гравці',
  'gameDetail.tabInfo': 'Інфо',
  'gameDetail.joined': 'У грі',
  'gameDetail.confirmedPlayers': 'Підтверджені гравці ({n})',
  'gameDetail.pricePerPlayer': 'З гравця',

  'create.title': 'Нова гра',
  'create.subtitle': 'Заповніть деталі та запросіть гравців',
  'create.field.playType': 'Де буде гра',
  'create.playType.indoor': 'У залі',
  'create.playType.outdoor': 'На вулиці',
  'create.playType.beach': 'На пляжі',
  'create.section.where': 'Де',
  'create.section.when': 'Коли',
  'create.section.who': 'Хто',
  'create.section.cost': 'Вартість',
  'create.section.notes': 'Нотатки',
  'create.section.covers': 'Фото майданчика',
  'game.coversTitle': 'Фото майданчика',
  'game.coversHint': 'Необов’язково — одне фото майданчика. JPEG/PNG/WebP, до 2 МБ. Зберігається в профілі для наступної гри.',
  'game.coversAdd': 'Додати фото',
  'game.coversClear': 'Прибрати своє фото',
  'game.coversReuseHint': 'Використовуємо збережене фото майданчика — торкніться, щоб замінити, або створіть гру як є.',
  'gameDetail.activityTitle': 'Активність гравців',
  'gameDetail.notifyCount': '{n} натиснули «Повідомити мене»',
  'gameDetail.activityEmpty': 'Ще немає входів/виходів.',
  'gameDetail.activityJoined': '«{name}» зайшов у гру · {when}',
  'gameDetail.activityLeft': '«{name}» вийшов з гри · {when}',
  'create.field.venue': 'Майданчик',
  'create.field.savedPlaces': 'Збережені місця',
  'create.field.savedPlacesPlaceholder': 'Оберіть збережене місце…',
  'create.field.noSavedPlaces': 'Збережених місць ще немає. Адреса збережеться після створення гри.',
  'create.field.placeName': 'Назва місця',
  'create.field.placeNamePlaceholder': 'напр. майданчик у парку або шкільна зала',
  'create.field.venueAddress': 'Адреса',
  'create.field.venueAddressPlaceholder': 'напр. вул. Piekary 17, Poznan',
  'create.field.selectVenue': '— оберіть майданчик —',
  'create.field.start': 'Початок',
  'create.field.duration': 'Годин',
  'create.field.skill': 'Рівень гри',
  'create.field.spots': 'Всього місць',
  'create.field.unlimited': 'Без обмеження',
  'create.field.totalCost': 'Загальна вартість майданчика',
  'create.field.currency': 'Валюта',
  'create.field.addressHint': 'Адреса / місце зустрічі',
  'create.field.addressHintPlaceholder': 'напр. боковий вхід, парк за торговим центром',
  'create.field.coverPreview': 'Обкладинка',
  'create.field.coverPreviewHint': 'Автоматично підбирається за типом гри.',
  'create.field.paid': 'Це платна гра',
  'create.paidStatus.on': 'Платна гра — гравці мають сплатити свою частину.',
  'create.paidStatus.off': 'Безкоштовна гра — залиште вартість 0, щоб гра була безкоштовною.',
  'create.field.noVenues': 'У вашому місті ще немає майданчиків. Додайте з вкладки Ігри.',
  'create.field.closed': 'Закрите лобі (лише запрошення)',
  'create.cta': 'Створити гру',
  'create.cta.creating': 'Створюємо…',
  'create.cost.auto': 'Авто: {venue} × {hours} год.',
  'create.cost.custom': 'Ви вказали свою вартість.',
  'create.cost.empty': 'Оберіть майданчик, щоб заповнити автоматично.',
  'create.cost.manual': 'Збережені місця з ціною заповнять вартість автоматично. Інакше введіть її вручну.',
  'create.perPlayer': 'З гравця: {amount}',
  'create.splitBetween': 'Ділимо на {n} гравців',
  'create.unlimitedHint': 'Без верхньої межі кількості гравців',
  'create.venueMax': 'Макс. на майданчику: {n} гравців',

  'blacklist.title': 'Заблоковані гравці',
  'blacklist.empty': 'Ви нікого не заблокували.',
  'blacklist.add': 'Заблокувати гравця',
  'blacklist.reason': 'Причина (необов\'язково)',
  'blacklist.remove': 'Розблокувати',
  'blacklist.maxed': 'Можна заблокувати до 10 гравців. Спочатку розблокуйте когось.',
  'blacklist.warning.title': 'У грі є заблокований гравець',
  'blacklist.warning.body': 'Ви заблокували {name}. Ви впевнені, що хочете приєднатися?',
  'blacklist.warning.confirm': 'Приєднатися',
  'blacklist.warning.cancel': 'Скасувати',

  'report.title': 'Поскаржитися на гравця',
  'report.reason.toxic': 'Токсична поведінка',
  'report.reason.skipped': 'Не прийшов на гру',
  'report.reason.harassment': 'Домагання',
  'report.reason.cheating': 'Шахрайство',
  'report.reason.other': 'Інше',
  'report.details': 'Деталі (необов\'язково)',
  'report.submit': 'Надіслати скаргу',
  'report.thanks': 'Дякуємо — адміни розглянуть скаргу.',

  'eval.title': 'Оцінити гравців',
  'eval.subtitle': 'Оцініть кого хочете — «Пропустити» біля імені, або просто надішліть оцінки для обраних.',
  'eval.alreadyRated': 'Вже оцінено',
  'eval.skip': 'Пропустити',
  'eval.skipAll': 'Пропустити всіх',
  'eval.skipPlayer': 'Пропустити',
  'eval.skipped': 'Пропущено',
  'eval.undoSkip': 'Оцінити',
  'eval.done': 'Готово',
  'eval.levelN': 'Рів. {n}',
  'eval.noPlayers': 'Немає співгравців для оцінки.',
  'eval.submit': 'Надіслати оцінки',
  'eval.thanks': 'Дякуємо — ваші оцінки збережено.',
  // New "Looks right / Suggest different" UX.
  'eval.looksRight': 'Все вірно · Рівень {n}',
  'eval.suggestDifferent': 'Запропонувати інший рівень',

  'invite.title': 'Запрошення',
  'invite.empty': 'Немає нових запрошень.',
  'invite.emptySearch': 'Поки немає гравців — спробуй імʼя або @username.',
  'invite.accept': 'Прийняти',
  'invite.decline': 'Відхилити',
  'invite.ignore': 'Ігнорувати',
  'invite.invitePlayer': 'Запросити гравця',
  'invite.bannerTitle': 'У вас нове запрошення на гру',
  'invite.openGame': 'Відкрити гру',
  'invite.invited': 'Запрошення надіслано',
  'invite.invitedTo': 'Запрошення надіслано: {name}',
  'invite.inviteFailed': 'Не вдалося запросити {name}',
  'invite.searchPlaceholder': 'Пошук за іменем або @username',
  'invite.noResults': 'За вашим запитом гравців не знайдено',
  'invite.inviteAction': 'Запросити {name}',
  'invite.notifyAria': '{count} очікуваних запрошень',
  'invite.sentTitle': 'Надіслані',
  'invite.statusSent': 'Надіслано',
  'invite.statusRead': 'Прочитано',
  'invite.statusAccepted': 'Прийнято',
  'invite.statusDeclined': 'Відхилено',
  'invite.statusIgnored': 'Проігноровано',
  'invite.statusInactive': 'Неактивне',
  'invite.resend': 'Ще раз',
  'invite.resendAria': 'Надіслати запрошення ще раз: {name}',
  'invite.resentTo': 'Запрошення повторно надіслано: {name}',

  'payments.title': 'Платежі',
  'payments.totalCost': 'Загальна вартість',
  'payments.perPlayer': 'З гравця',
  'payments.collected': 'Зібрано',
  'payments.cashCollected': 'Зібрано готівкою',
  'payments.methodHint': 'Натисніть $ (готівка) або картку (банк). Лише один варіант. Повторне натискання знімає позначку.',
  'payments.cashHint': 'Натисніть кнопку готівки, коли гравець сплатив вам готівкою на майданчику.',
  'payments.players': 'Гравці',
  'payments.status': 'Статус',
  'payments.paid': 'Сплачено',
  'payments.paidCash': 'Готівка',
  'payments.paidBank': 'Банк',
  'payments.unpaid': 'Не сплачено',
  'payments.markPaid': 'Позначити сплаченим',
  'payments.markPaidCash': 'Позначити сплаченим готівкою',
  'payments.markPaidBank': 'Позначити сплаченим переказом',
  'payments.markUnpaid': 'Позначити несплаченим',
  'payments.myUnpaid': 'Ви винні {amount} за {venue}',

  'calendar.title': 'Календар',
  'calendar.today': 'Сьогодні',
  'calendar.upcoming': 'Майбутні',
  'calendar.past': 'Минулі',

  'lang.title': 'Мова',
  'lang.uk': 'Українська',
  'lang.pl': 'Polski',
  'lang.en': 'English',
  'lang.ru': 'Москальска',

  'auth.banned.title': 'Вас заблоковано',
  'auth.banned.body': 'Причина: {reason}',
  'auth.banned.contact': 'Зв\'яжіться з підтримкою, якщо вважаєте це помилкою.',

  'common.cancel': 'Скасувати',
  'common.save': 'Зберегти',
  'common.delete': 'Видалити',
  'common.confirm': 'Підтвердити',
  'common.search': 'Пошук',
  'common.loading': 'Завантаження…',
  'common.retry': 'Спробувати ще',
  'common.error': 'Щось пішло не так',
  'common.close': 'Закрити',
  'common.back': 'Назад',
  'common.optional': 'Необов\'язково',
  'common.you': 'Ви',

  'userProfile.view': 'Переглянути профіль',
  'userProfile.viewNamed': 'Профіль гравця {name}',
  'userProfile.openTelegram': 'Відкрити в Telegram',
  'userProfile.message': 'Написати в Telegram',
  'userProfile.block': 'Заблокувати',
  'userProfile.blockConfirm': 'Заблокувати {name}? Гравець не з\'являтиметься у ваших підказках.',
  'userProfile.notFound': 'Гравця не знайдено',
  'userProfile.notFoundText': 'Цей профіль видалено або він недоступний.',

  'banner.signOut': 'Ви вийшли з акаунту.',
  'banner.saved': 'Збережено.',
  'banner.deleted': 'Видалено.',

  'admin.title': 'Адмін-панель',
  'admin.subtitle': 'Керуйте користувачами, іграми, скаргами та збереженими місцями.',
  'admin.subtitleSection': 'Адмін · {section}',
  'admin.users': 'Користувачі',
  'admin.activity': 'Використання додатку',
  'admin.games': 'Ігри',
  'admin.venues': 'Майданчики',
  'admin.reports': 'Скарги',
  'admin.ratings': 'Виставлені оцінки',
  'admin.fb': 'FB',
  'admin.audit': 'Аудит',
  'admin.heatmap': 'Теплова карта',
  'admin.stats': 'Статистика',
  'admin.search': 'Пошук…',
  'admin.ban': 'Заблокувати',
  'admin.unban': 'Розблокувати',
  'admin.banReason': 'Причина блокування',
  'admin.userDetails': 'Деталі користувача',
  'admin.userSkill': 'Рівень навички',
  'admin.userSkillHint': 'Встановіть бал на бейджі. Блокування не дає оцінкам гравців його змінити.',
  'admin.userSkillSave': 'Зберегти бал',
  'admin.userSkillSaved': 'Бал збережено.',
  'admin.userSkillClear': 'Очистити бал',
  'admin.userSkillLock': 'Заблокувати від оцінок гравців',
  'admin.userWheelchair': 'Показувати іконку візка замість числа',
  'admin.userActivity': 'Активність',
  'admin.appUsage': 'Використання додатку',
  'admin.stat.visited': 'Відвідано',
  'admin.stat.cancelled': 'Скасовано',
  'admin.stat.created': 'Створено',
  'admin.stat.sessionsPerWeek': 'Сесій / тиж',
  'admin.stat.entriesDay': 'Входів / день',
  'admin.stat.entriesWeek': 'Входів / тиждень',
  'admin.stat.entriesMonth': 'Входів / місяць',
  'admin.stat.avgTimeInApp': 'Сер. час у додатку',
  'admin.stat.lastActive': 'Остання активність',
  'admin.stat.evalGiven': 'Оцінок виставлено',
  'admin.stat.evalReceived': 'Оцінок отримано',
  'admin.stat.reportsAgainst': 'Скарг на користувача',
  'admin.stat.paymentsMade': 'Оплат зроблено',
  'admin.stat.evaluatedSkill': 'Оцінений рівень',
  'admin.bannedWithReason': 'Заблоковано: {reason}',
  'admin.roleAdmin': 'Адмін',
  'admin.badgeBanned': 'Заблокований',
  'admin.filterBanned': 'Заблоковані',
  'admin.filterActive': 'Активні',
  'admin.deleteUser': 'Видалити користувача',
  'admin.deleteUserConfirm': 'Видалити користувача {name}? Цю дію не можна скасувати.',
  'admin.cancelGame': 'Скасувати гру',
  'admin.resolve': 'Позначити розглянутою',
  'admin.dismiss': 'Відхилити',
  'admin.resolveAndBan': 'Розглянуто + бан',
  'admin.index.stats': 'Користувачі, ігри, місця та реєстрації',
  'admin.index.users': 'Керуйте ролями, банами та активністю',
  'admin.index.activity': 'Входи та час у додатку для кожного користувача',
  'admin.index.games': 'Скасовуйте, завершуйте або перевіряйте будь-яку гру',
  'admin.index.venues': 'Переглядайте збережені місця, що використовують в іграх',
  'admin.index.reports': 'Переглядайте та вирішуйте скарги',
  'admin.index.ratings': 'Точні оцінки, які гравець поставив іншим',
  'admin.ratingsSearch': 'Знайти гравця…',
  'admin.ratingsPick': 'Знайдіть гравця, щоб побачити оцінки, які він поставив.',
  'admin.ratingsFrom': 'Оцінки, які поставив цей гравець',
  'admin.ratingsEmpty': 'Цей гравець ще нікого не оцінював.',
  'admin.ratingsCount': '{n} оцінок',
  'admin.index.fb': 'Волейбольні оголошення з групи Facebook за цей тиждень',
  'admin.fbHint': 'Вставте пости за цей тиждень. Кілька постів розділіть рядком, на якому лише ---. Komplet, Komplekt або Full означає, що гра повна. «przy komplecie» — це ціна, а не повна гра.',
  'admin.fbGroup': 'Відкрити групу Facebook',
  'admin.fbPaste': 'Текст поста',
  'admin.fbLink': 'Посилання (необовʼязково)',
  'admin.fbAdd': 'Додати на дошку',
  'admin.fbEmpty': 'Цього тижня на дошці немає оголошень.',
  'admin.fbStatus': 'Статус',
  'admin.fbDate': 'Дата',
  'admin.fbLevel': 'Рівень',
  'admin.fbPlaces': 'Вільні місця',
  'admin.fbAddress': 'Адреса',
  'admin.fbPostLink': 'Посилання',
  'admin.fbOpen': 'Є місця',
  'admin.fbFull': 'Повна',
  'admin.fbDelete': 'Видалити',
  'admin.fbRaw': 'Початковий пост',
  'admin.fbAdded': 'Додано {n}',
  'admin.fbMissing': '—',
  'admin.activityEmpty': 'Немає користувачів за вашим пошуком.',
  'admin.activityShowing': 'Показано {shown} з {total}',
  'admin.stat.entriesDayShort': 'День',
  'admin.stat.entriesWeekShort': 'Тиждень',
  'admin.stat.entriesMonthShort': 'Місяць',
  'admin.stat.avgTimeShort': 'Сер. час',
  'admin.stat.neverActive': 'Ніколи не відкривав додаток',
  'admin.stat.activeJustNow': 'Активний щойно',
  'admin.stat.activeMinutesAgo': 'Активний {n} хв тому',
  'admin.stat.activeHoursAgo': 'Активний {n} год тому',
  'admin.stat.dau': 'DAU',
  'admin.stat.wau': 'WAU',
  'admin.stat.mau': 'MAU',
  'admin.stat.sessionsToday': 'Сесій сьогодні',
  'admin.stat.avgSession': 'Сер. сесія',
  'admin.stat.signups24h': 'Реєстрації (24 год)',
  'admin.stat.finishedGames': 'Завершені ігри',
  'admin.stat.topScreens': 'Топ екранів (7 дн)',
  'admin.stat.topActions': 'Топ дій (7 дн)',
  'admin.stat.topClicks': 'Топ кліків (7 дн)',
  'admin.stat.platforms': 'Платформи (7 дн)',
  'admin.stat.languages': 'Мови (7 дн)',
  'admin.stat.rankEmpty': 'Поки немає даних — користуйтесь додатком.',
  'admin.index.heatmap': 'Де користувачі натискають на екранах',
  'admin.heatmapFilter': 'Фільтр за шляхом екрана…',
  'admin.heatmapEmpty': 'Поки немає кліків.',
  'admin.heatmapAvgPos': 'сер. тап ({x}, {y})',
  'venue.indoor': 'У приміщенні',
  'venue.outdoor': 'Надворі',

  'error.network': 'Помилка мережі. Спробуйте ще.',
  'error.unauthorized': 'Увійдіть ще раз.',
  'error.forbidden': 'У вас немає дозволу.',
  'error.notFound': 'Не знайдено.',
  'error.tooLarge': 'Файл завеликий.',
  'error.unknown': 'Щось пішло не так.',

  'empty.notSignedIn': 'Ви не увійшли',
  'empty.notSignedInText': 'Відкрийте міні-додаток з Telegram, щоб налаштувати профіль.',

  'onboarding.chooseLevel': 'Оберіть свій рівень',
  'onboarding.levelPrompt': 'Оберіть рівень, який найкраще вас описує. Інші гравці використовують це для підбору ігор.',

  'city.default': 'Місто за замовчуванням',

  'msg.profileUpdated': 'Профіль оновлено',
  'msg.gameCreated': 'Гру створено',
  'msg.gameCancelled': 'Гру скасовано',
  'msg.gameLeft': 'Ви вийшли з гри',
  'msg.gameJoined': 'Ви приєдналися до гри',
  'msg.blacklistAdded': 'Гравця заблоковано',
  'msg.blacklistRemoved': 'Гравця розблоковано',
  'msg.reportSubmitted': 'Скаргу надіслано',
  'msg.evaluationsSubmitted': 'Оцінки збережено',
  'msg.invitationResponded': 'Запрошення оновлено',
  'msg.paymentUpdated': 'Платіж оновлено',
  'msg.languageUpdated': 'Мову оновлено',
  'msg.locationUpdated': 'Локацію оновлено',
  'msg.signOutDone': 'Ви вийшли',
};
